export default __webpack_public_path__ + "static/media/shrikeWithWords.666f91bd.png";